import { createDecorator } from '../../../../platform/instantiation/common/instantiation.js';
const IExtensionService = ( createDecorator('extensionService'));
export { IExtensionService };
